import React from "react";

import { TaxiServiceCellContent as Content } from "../components";

import base from "./base";

import { Column, ColumnId } from ".";

function taxiService({ width, onResize }: Column.Options) {
	return base(ColumnId.TaxiService, (item) => <Content item={item} />, {
		width,

		onResize: onResize as (
			columnWidth?: number | undefined,
			dataKey?: string | undefined,
		) => void,
	});
}

export default taxiService;
